<span *ngIf="document.totalWithTaxConverted" class="mr-1 badge badge-soft-secondary cursor-pointer"
  ngbTooltip="{{ valueConverted(document) | pepCurrency: currencyConverted(document): activeOrg.locale }}"
  (click)="onToggleShowConverted()"
>
  <i class="fe fe-shuffle fe-fw"></i>
</span>
{{
  value(document)
    | pepCurrency: currency(document):activeOrg.locale
}}